<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-card color="transparent" flat>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title class="font-weight-bold">{{ $t('geneticsAndBreeding.epdRequiredFieldSettings') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn outlined depressed color="primary" class="mr-2">Cancel</v-btn> -->
        <v-btn color="primary" @click="confirmDialog = true">{{ $t('save') }}</v-btn>
      </v-toolbar>
      <v-card-text class="v-card__body">
        <h3 class="black--text pb-8">{{ $t('geneticsAndBreeding.pleaseSelectRequiredFieldsForCompleteEPD') }}</h3>

        <hr class="grey-hr" />

        <v-row class="pt-8">
          <v-col cols="6">
            <label class="input-label">{{ $t('geneticsAndBreeding.selectTrait') }} 
              <v-tooltip max-width="250px" top color="black">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    v-bind="attrs"
                    v-on="on">
                    mdi-information-outline
                    </v-icon>
                </template>
                <span>{{ $t('geneticsAndBreeding.traitH') }}</span>
              </v-tooltip>
            </label>
            <v-select :items="traits" item-text="label" item-value="value" v-model="trait" outlined dense @change="getInitialDetails"></v-select>

            <v-row>
              <v-col cols="6" class="py-1" v-for="(item, index) in requiredFields" :key="index">
                <v-checkbox v-model="item.status" :label="item.name" :disabled="contemporaryGroupCount>0" color="primary" hide-details>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <div class="bottom-banner">
          {{ $t('geneticsAndBreeding.pleaseNoteThatUsersNotAbleToObtainFullEPD') }}
        </div>
        <div class="note-banner" v-if="contemporaryGroupCount>0">
          {{ $t('geneticsAndBreeding.pleaseNoteThatRequiredFieldParametersCannotBeChanged') }}
        </div>
      </v-card-text>

      <v-dialog v-model="confirmDialog" width="500" @click:outside="confirmDialog=false" :retain-focus="false">
        <v-card class="custom-card" rounded="0">
          <v-toolbar color="secondary" class="white--text" flat>
            <v-toolbar-title class="font-weight-bold">
              {{ $t('warning') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="confirmDialog=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-form lazy-validation autocomplete="off">
            <v-card-text class="black--text">
              <v-row>
                <v-col cols="12" >
                  <div class="text-center">
                    <img src="../../assets/warning.svg" />
                  </div>
                  <div class="py-5 text-center">
                    {{ $t('geneticsAndBreeding.areYouSureYouWantToChangeEPDCalculation') }}
                  </div>
                  
                </v-col>
              </v-row>
              <v-divider class="mt-5"></v-divider>
              <v-card-actions class="mt-2" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn outlined class="mr-2" right height="44" width="116" depressed color="primary"
                  @click="confirmDialog = false">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn right height="44" width="116" color="primary" depressed @click="updateRequiredFields">
                  {{ $t('proceed') }}
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import EPDsettingsService from '@/_services/EPDsettingsService';
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  name: 'EPDRequiredFieldsSetting',
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('Genetics & Breeding'),
          disabled: false,
          link: true,
          exact: true,
          to: { name: "Genetics" },
        },
        {
          text: this.$t('EPD Required Field Settings'),
          disabled: true
        },
      ],
      traits: [
        {
          label: 'Birth Weight',
          value: 'birthWeight'
        },
        {
          label: 'Weaning Weight',
          value: 'weaningWeight'
        },
        {
          label: 'Yearling Weight',
          value: 'yearlingWeight'
        },
        {
          label: 'Carcass Weight',
          value: 'carcassWeight'
        }
      ],
      trait: 'birthWeight',
      requiredFields: [],
      confirmDialog: false,
      contemporaryGroupCount: 0,
    }
  },
  mixins: [loadingMixin],
  methods: {
    async getRequiredFields() {
    // const res = await axios.get(`/animalGenetics/epdRequiredFieldsSetting/${this.trait}`)
    this.startLoading();
    const res = await EPDsettingsService.getEPDsettings(this.traits.find(item => item.value === this.trait).label)
    if (res.data.success) {
      this.requiredFields = res.data.data.requiredFields
      this.contemporaryGroupCount = res.data.data.count
      this.stopLoading();
    } else {
      this.$notify({
        title: "Error fetching required fields.",
        text: res.data.message,
        type: "error",
      });
      this.stopLoading();
    }
  },
  async getInitialDetails(){
    this.getRequiredFields();
  },
  async updateRequiredFields() {
    const res = await axios.put(`/animalGenetics/epdRequiredFieldsSetting/${this.traits.find(item => item.value === this.trait).label}`, {
      requiredFields: this.requiredFields
    })
    if (res.data.success) {
      this.confirmDialog = false
      this.requiredFields = res.data.data.requiredFields
      this.$notify({
        title: "Success",
        text: res.data.message,
        type: "success",
      });
    } else {
      this.$notify({
        title: "Error",
        text: res.data.message,
        type: "error",
      });
    }
  }
  },
  created() {
    this.getInitialDetails();
  }
}
</script>
<style scoped>
.v-card__body {
  background-color: #ffffff;
  padding: 24px;
  margin: 16px;
}

.grey-hr {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: none;
}

.input-label {
  color: #1E1E1E;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.input-label i {
  font-size: 20px;
  margin-left: 8px;
}

.bottom-banner {
  margin-top: 60px;
  background-color: #FFF7EC;
  border: 1px solid #FFB443;
  border-radius: 5px;
  padding: 18px 26px;
}

.note-banner {
  margin-top: 10px;
  background-color: #FFF7EC;
  border: 1px solid #FFB443;
  border-radius: 5px;
  padding: 18px 26px;
}
.bottom-banner .note-banner strong {
  font-weight: 600;
  color: #1E1E1E;
}
</style>